// Badge di stato proposta. Redesign 27/10: forma e palette dei badge della
// lista ordini. PIENO = e' cosi' (da fare, fatta), CONTORNO = in attesa o
// spenta, la stessa regola di `statoToni`.
import {
  contorno,
  FORMA_BADGE,
  pieno,
  type StatoTone,
} from "@/features/ordini/components/statoToni";
import type { ProposalStatus } from "../types";

const LABELS: Record<ProposalStatus, string> = {
  da_fatturare: "Da fatturare",
  in_revisione: "In revisione",
  esclusa: "Esclusa",
  fatturata: "Fatturata",
  da_inviare: "Da inviare",
  in_attesa_spedizione: "Attesa spedizione",
  in_attesa_pagamento: "Attesa pagamento",
};

const TONI: Record<ProposalStatus, { tono: StatoTone; pieno: boolean }> = {
  da_fatturare: { tono: "nuovo", pieno: true },
  in_revisione: { tono: "in-corso", pieno: true },
  esclusa: { tono: "annullato", pieno: false },
  fatturata: { tono: "pagato", pieno: true },
  da_inviare: { tono: "bonifico", pieno: true },
  in_attesa_spedizione: { tono: "spedito", pieno: false },
  in_attesa_pagamento: { tono: "da-pagare-atteso", pieno: false },
};

export function StatusBadge({ status }: { status: ProposalStatus }) {
  const t = TONI[status];
  return (
    <span
      data-tono={t.tono}
      className={FORMA_BADGE}
      style={t.pieno ? pieno(t.tono) : contorno(t.tono)}
    >
      {LABELS[status]}
    </span>
  );
}
